import { render, staticRenderFns } from "./platform-revenue.vue?vue&type=template&id=dbf02d08&scoped=true&"
import script from "./platform-revenue.vue?vue&type=script&lang=js&"
export * from "./platform-revenue.vue?vue&type=script&lang=js&"
import style0 from "./platform-revenue.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./platform-revenue.vue?vue&type=style&index=1&id=dbf02d08&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf02d08",
  null
  
)

export default component.exports